import React, { useRef } from "react";
import axios from "axios";
import { Mail } from "lucide-react";
import { toast } from "react-toastify";

const ContactForm = () => {
  const form = useRef();

  const sendEmail = async (e) => {
    e.preventDefault();

    const formData = new FormData(form.current);
    const data = {
      firstName: formData.get("first_name"),
      lastName: formData.get("last_name"),
      phone: formData.get("user_phone"),
      email: formData.get("user_email"),
      subject: formData.get("subject"),
      message: formData.get("message"),
    };

    try {
      const response = await axios.post(process.env.REACT_APP_CONTACT_API, data, {
        headers: { "Content-Type": "application/json" },
      });
      

      if (response.status === 200) {
        toast.success("✅ Message sent successfully. Thank you email delivered.");
        form.current.reset();
      } else {
        toast.error(`❌ ${response.data?.error || "Failed to send message. Please try again."}`);
      }
    } catch (error) {
      toast.error(
        `❌ ${error.response?.data?.error || "Failed to send message. Please check your connection."}`
      );
    }
  };

  return (
    <div className="md:max-w-3xl bg-gray-200 shadow-xl rounded-lg md:p-8 p-4">
      <form ref={form} onSubmit={sendEmail} className="space-y-6">
        <div className="grid md:grid-cols-2 gap-4">
          <div className="w-full">
            <label className="text-sm text-text_color-200 mb-1">First Name</label>
            <input type="text" name="first_name" className="input-field" required />
          </div>
          <div className="w-full">
            <label className="text-sm text-text_color-200 mb-1">Last Name</label>
            <input type="text" name="last_name" className="input-field" />
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm text-text_color-200 mb-1">Phone</label>
            <input type="text" name="user_phone" className="input-field" />
          </div>
          <div>
            <label className="block text-sm text-text_color-200 mb-1">Email</label>
            <input type="email" name="user_email" className="input-field" required />
          </div>
        </div>

        <div>
          <label className="block text-sm text-text_color-200 mb-1">Subject</label>
          <input type="text" name="subject" className="input-field" />
        </div>

        <div>
          <label className="block text-sm text-text_color-200 mb-1">Message</label>
          <textarea name="message" rows="4" className="input-field" required />
        </div>

        <button
          type="submit"
          className="w-full flex items-center justify-center gap-2 bg-primary-200 text-white rounded-md font-medium py-3 transition"
        >
          <Mail size={18} /> Send Message
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
